import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PodcastLanding } from '@src/components/sco/Education/PodcastLanding';
import { PodcastSearch } from '@src/components/sco/Education/PodcastSearch';
import { EducationPage } from '@src/templates/EducationPage';
import React, { useEffect } from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  useEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
      // isDrawerOpen: false,
    });
    educationContext.setActiveSection('podcast.landing');
    educationContext.setActiveContentItem(null);
  }, []);
  const showSearch = educationContext.activeTerms?.length > 0 || educationContext.activeKeywords;
  return showSearch ? <PodcastSearch /> : <PodcastLanding />;
});